import useMutation from 'hooks/use-mutation';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import { addSurfaceNodeToSurfaceProtocolNodeMutation } from 'graphql/surface-node/mutations/surface-protocol-node/add-surface-node-to-surface-protocol-node';
import { set, compose } from 'lodash/fp';
import { SurfaceNodeUnion, SurfaceProtocolNode } from 'graphql/types';
import useFindNodeInCache from 'components/canvas/hooks/use-find-node';
import { PROTOCOL_PADDING } from 'components/canvas/components/nodes/components/protocol-node';

export default function useAddSurfaceNodeToSurfaceProtocolNode(
  surfaceId: string,
) {
  const saveNodeInCache = useSaveNodeInCache();

  const { findNodeById } = useFindNodeInCache();

  const [addSurfaceNodeToSurfaceProtocolNode] = useMutation(
    addSurfaceNodeToSurfaceProtocolNodeMutation,
  );

  return async (params) => {
    const input = params?.variables?.input;

    let protocolNode = findNodeById(input?.protocolNode);

    const isOriginalOnSameSurface =
      protocolNode?.surface?.id === protocolNode?.originalNode?.surface?.id;

    const node = findNodeById(input?.node);

    if (protocolNode.isReference && isOriginalOnSameSurface) {
      //@ts-ignore
      protocolNode = protocolNode?.originalNode;

      params.variables.positionInput.position = {
        //@ts-ignore
        x: protocolNode?.position?.x + PROTOCOL_PADDING,
        //@ts-ignore
        y: protocolNode?.position?.y + PROTOCOL_PADDING,
      };
    }

    input.protocolNode = protocolNode.id;

    //@ts-ignore
    const newProtocolNode = setContainingNode(protocolNode, node);

    saveNodeInCache(newProtocolNode);

    return addSurfaceNodeToSurfaceProtocolNode(params);
  };
}

function setContainingNode(
  protocolNode: SurfaceProtocolNode,
  containingNode: SurfaceNodeUnion,
): SurfaceProtocolNode {
  return compose(set('contains', containingNode))(protocolNode);
}
